import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function ConfigSeparator({ className = '' }) {
  return <div className={cn(styles.container, className)}></div>;
}
